export async function getEthUsdPrice() {
  return 0;
}

export function getUsdPriceForSymbol(symbol, ethPrice) {
  const upper = String(symbol || '').toUpperCase();
  if (upper === 'USDC' || upper === 'USDC.E') return 1;
  if (upper === 'ETH') return ethPrice;
  if (upper === 'STETH') return ethPrice; // stETH is priced as ETH for v1.
  return null;
}
